// components/Spinner.js
import React from "react";
import { ScaleLoader } from "react-spinners";

const Spinner = () => {
  return (
    <div className="overlay">
      <div className="spinner" />
        <ScaleLoader
            color={'#1a4480'}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
    </div>
  );
};

export default Spinner;
